export const CAPTION_TYPES = ['CAPTION', 'VTT_CAPTION'];